import { useDispatch, useSelector } from 'react-redux';
import { getJobManagerTablePagination } from 'modules/jobManager/ducks/selectors';
import { PAGE_SIZES_MEDIUM, PaginationFooter, PaginationUpdateEvent } from 'ui/paginationFooter';
import { setJobTablePage, setJobTablePageSize } from 'modules/jobManager/ducks/actions';

export const JobManagerTablePagination = () => {
  const dispatch = useDispatch();
  const { page, pageSize, count } = useSelector(getJobManagerTablePagination);

  const updatePagination = ({ page: newPage, pageSize: newPageSize }: PaginationUpdateEvent) => {
    dispatch(setJobTablePage(newPage));
    dispatch(setJobTablePageSize(newPageSize));
  };

  return (
    <PaginationFooter
      onUpdate={updatePagination}
      pageSizes={PAGE_SIZES_MEDIUM}
      currentPage={page}
      itemsPerPage={pageSize}
      numItems={count}
    />
  );
};
